import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalAnaliseColetaIndicador from "components/modal/indicadores/ModalAnaliseColetaIndicador";
import ModalColetaIndicador from "components/modal/indicadores/ModalColetaIndicador";
import Processo from "model/indicadores/Processo";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import IndicadorMinhasAnalisesColetasService from "service/indicadores/IndicadorMinhasAnalisesColetasService";
import IndicadorService from "service/indicadores/IndicadorService";
import { dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const indicadorService = new IndicadorService();
const indicadorMinhasAnalisesColetasService = new IndicadorMinhasAnalisesColetasService();
export default function IndicadorMinhasAnalisesColetasListagem() {

    const listagemRef = useRef<BaseListagemRef>(null);
    const [titulo, setTitulo] = useState<string>('Minhas Análises');
    const navigate = useNavigate();
    const [modalAnaliseColeta, setModalAnaliseColeta] = useState<{ visible: boolean, indicadorId: number }>({ visible: false, indicadorId: 0 });

    const [processos, setProcessos] = useState<Processo[]>([]);
    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);

    useEffect(() => {
        indicadorService.processos().then((response) => {
            setProcessos(response);
        }).catch((error) => {
            console.error("Erro ao buscar processos:", error);
        });

        indicadorService.unidadesOrgan().then((response) => {
            setUnidades(response);
        }).catch((error) => {
            console.error("Erro ao buscar unidades organizacionais:", error);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        processo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        unidadeOrganizacional: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }
    return (
        <>
            {modalAnaliseColeta.visible && <ModalAnaliseColetaIndicador visible={modalAnaliseColeta.visible}
                onHide={() => {
                    setModalAnaliseColeta({ visible: false, indicadorId: 0 });
                    listagemRef.current?.reload();
                }}
                indicadorId={modalAnaliseColeta.indicadorId}
            />}

            <BaseListagem
                ref={listagemRef}
                ordenacao={"dataProximaColeta,ASC"}
                service={indicadorMinhasAnalisesColetasService}
                showEditButton={false} showRemoveButton={false} showNewButton={false}
                urlService={"/indicador"}
                tituloPagina={titulo}
                nome="indicadorMinhasColetas"
                defaultFilters={defaultFilters}
                showClearFilterButton
            >
                <Column field="codigo" header="Código" filterField="codigo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="nome" header="Nome" filterField="nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="processo.nome" header="Processo" filter filterField="processo" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, processos)} />
                <Column field="unidadeOrganizacional.nome" header="Unid. Organ." filter filterField="unidadeOrganizacional" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, unidades)} />
                <Column field="analisesPendentes" header="Análises Pendentes" />
                <Column body={(rowData) => {
                    return <Button icon="pi pi-eye" className="p-button-rounded p-button-info" onClick={() => {
                        navigate(`/indicador/dashboard/${rowData.id}`)
                    }} />
                }} />
                <Column body={(rowData) => {
                    return <Button icon="pi pi-list" className="p-button-rounded p-button-info" onClick={() => {
                        setModalAnaliseColeta({ visible: true, indicadorId: rowData.id })
                    }} />
                }} />
            </BaseListagem>
        </>
    )
}